// src/pages/Estatisticas/components/ModelUsageStats.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ModelUsageStats = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    carregarEstatisticas();
  }, []);

  const carregarEstatisticas = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.get('/api/estatisticas/uso-por-modelo');
      
      if (response.data.success) {
        setStats(response.data.data);
      } else {
        setError(response.data.message || 'Erro ao carregar estatísticas');
      }
    } catch (err) {
      console.error('Error loading model stats:', err);
      setError('Erro ao carregar estatísticas: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const formatarNumero = (numero) => {
    return numero.toLocaleString('pt-BR');
  };

  const formatarLatencia = (segundos) => {
    return segundos.toFixed(2) + 's';
  };

  if (loading) {
    return (
      <div className="stat-box">
        <h3>🤖 Uso por Modelo de IA</h3>
        <div className="loading-stats">
          <span>⏳</span>
          <span>Carregando estatísticas...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stat-box">
        <h3>🤖 Uso por Modelo de IA - ultimos 90 dias</h3>
        <div className="error-stats">{error}</div>
      </div>
    );
  }

  if (stats.length === 0) {
    return (
      <div className="stat-box">
        <h3>🤖 Uso por Modelo de IA - ultimos 90 dias</h3>
        <div className="no-stats">
          <span>📊</span>
          <span>Nenhuma estatística disponível ainda</span>
        </div>
      </div>
    );
  }

  return (
    <div className="stat-box">
      <h3>🤖 Uso por Modelo de IA  - ultimos 90 dias</h3>
      
      <div className="stats-table">
        <div className="table-header-estat">
          <div className="table-cell">Modelo</div>
          <div className="table-cell">Total Req.</div>
          <div className="table-cell">Tokens Input</div>
          <div className="table-cell">Tokens Output</div>
          <div className="table-cell">Total Tokens</div>
          <div className="table-cell">Latência Média</div>
        </div>
        
        {stats.map((stat, index) => (
          <div key={index} className="table-row-estat">
            <div className="table-cell model-name">{stat.model}</div>
            <div className="table-cell">{formatarNumero(stat.totalRequisicoes)}</div>
            <div className="table-cell">{formatarNumero(stat.inputTokens)}</div>
            <div className="table-cell">{formatarNumero(stat.outputTokens)}</div>
            <div className="table-cell total-tokens">{formatarNumero(stat.totalTokens)}</div>
            <div className="table-cell latency">{formatarLatencia(stat.latenciaMedia)}</div>
          </div>
        ))}
      </div>

      <div className="stats-summary">
        <p>Total de {stats.length} modelo{stats.length !== 1 ? 's' : ''} em uso</p>
      </div>
    </div>
  );
};

export default ModelUsageStats;